import { productIdFormat } from "@redotech/redo-product-id";
import { taskIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const addCycleCountProducts = {
  name: "addCycleCountProducts" as const,
  input: z.object({
    taskId: taskIdFormat.schema,
    productIds: z.array(productIdFormat.schema).min(1).max(500),
  }),
  output: z.object({ addedCount: z.number() }),
};
